import { useContext } from 'react';

import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MY_CARDS_REVEALABLE_CARDS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MyCardsLayoutContext } from '#src/layouts/my-cards/MyCardsLayout/MyCardsLayoutContext.tsx';

export const CardsPage = () => {
  const { defaultRarity } = useContext(MyCardsLayoutContext);
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_REVEALABLE_CARDS_TYPE, {
        params: {
          type: defaultRarity,
        },
      })}
      replace
    />
  );
};

export default CardsPage;
